import React from "react";

export const preparePager = (e, pager) => {
  if (e.filtered.length > 0) {
    let search = e.filtered.map((filter) => {
      return {
        field: filter.id,
        searchvalue: filter.value,
      };
    });
    pager.search = search;
  } else {
    pager.search = [];
  }
  if (e.sorted.length > 0) {
    pager.order = {
      field: e.sorted[0].id,
      sorttype: e.sorted[0].desc ? "desc" : "asc",
    };
  } else {
    pager.order = {};
  }
  pager.pagesize = e.pageSize;
  if (e.page === 0) {
    pager.pageno = 1;
  } else {
    pager.pageno = e.page + 1;
  }

  return pager;
};

export const prepareSearch = (term, columns, pager) => {
  if (term !== "" && columns) {
    let search = columns.map((column) => {
      return {
        field: column.field,
        searchvalue: term,
      };
    });
    pager.search = search;
  } else {
    pager.search = [];
  }

  return pager;
};

export const defaultPager = ({ limit }) => {
  return {
    manual: true,
    pageno: 1,
    pagesize: limit ? 5 : 100,
    order: {},
    search: [],
  };
};

export const getPresetDefaultColumns = (preset) => {
  const commonColumns = [
    "name",
    "result_teststatus",
    "result_testdate",
    "result_testtime",
    "result_tester",
    "result_neserialnumber"
  ];

  const lantekColumns = [
    "cabletypename", 
    "linkmodelname",
    "result_headroom",
    "result_cabletype",
    "cablestandardname",
    "result_length"
  ];

  const signaltekColumns = [
    "result_length",
    "result_transmission",
    "result_wiremap",
    "result_poeload",
    "result_fiber",
    "testinterface",
    "result_network", 
    "result_transmission",
    "result_wiremap", 
    "result_poeload", 
    "result_fiber",
    "testinterface"
  ];

  const vdvColumns = [
    "mobiletest_mode",
    "mobiletest_linkpulse",
    "mobiletest_poeclass",
    "mobiletest_onloadvoltageinvolts",
    "mobiletest_offloadvoltageinvolts",
    "mobiletest_poepowerinwatts",
    "mobiletest_cableinformation",
    "mobiletest_operatorname",
    "mobiletest_systemdevicetype",
    "result_length"
  ];

  switch (preset) {
    case "LanTEKIV":
    case "LanTEKIII":
      return [...commonColumns, ...lantekColumns];
    case "SignalTEK10G":
    case "SignalTEKQT":
    case "NaviTEKIII":
      return [...commonColumns, ...signaltekColumns];
    case "VDVII_PoEPro":
      return [...commonColumns, ...vdvColumns];
    default:
      return [
        ...commonColumns,
        ...lantekColumns,
        ...signaltekColumns,
        ...vdvColumns,
      ];
  }
};
